module.exports = __webpack_public_path__ + "static/media/logo-fr.ad12f2c9.svg";